import FaqAccordian from "./FaqAccordian";
import Why from "./Why";
import ProtectsAgainst from "./ProtectsAgainst";
import HowItWorks from "./HowItWorks";
import DataStatsSection from "./DataStatsSection";
import Pricing from "../pricing_page/Pricing";

const Home = () => {
  return (
    <>
      {/* Add margin top here */}
      <div>
        <Why />
      </div>
      <ProtectsAgainst />
      <HowItWorks />
      <DataStatsSection />
      <Pricing />
      <FaqAccordian />
    </>
  );
};

export default Home;
